module.exports = __webpack_public_path__ + "static/img/9.cc648b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/district/assets/image/home/9.png
// module id = q2zE
// module chunks = 3